<template>
  <!----学历---->
  <el-select v-model="educationCode" clearable>
    <el-option
      v-for="item in educationList"
      :key="item.dictCode"
      :label="item.dictName"
      :value="item.dictCode">
    </el-option>
  </el-select>
  <!------------->
</template>

<script>
  import {getListByTypeCodeAndPCode} from '@/api/dict/dic_manage'

  export default {
    name: "select-education",
    data() {
      return {
        educationList: [],
        educationCode: ''
      }
    },
    created() {
      let data = {
        dictTypeCode: 'EDUCATION',
        parentCode: -1,
      }
      getListByTypeCodeAndPCode(data).then(res => {
        if (res.code == 1) {
          this.educationList = res.data
        }
      })
    },
    watch: {
      educationCode: function (currentVal) {
        this.$emit('educationInfo', {educationCode: currentVal})
      }
    }
  }
</script>

<style scoped>

</style>
